import React from 'react'

const TextInput = ({ name, label, type = 'text', error, ...rest }) => (
  <div className="form-group">
    {label && <label htmlFor={name}>{label}</label>}
    <input
      type={type}
      className={`form-control${error ? ' is-invalid' : ''}`}
      id={name}
      name={name}
      aria-invalid={!!error}
      aria-describedby={error ? `${name}-error` : undefined}
      {...rest}
    />
    {error && (
      <div id={`${name}-error`} className="invalid-feedback">
        {error?.message}
      </div>
    )}
  </div>
)

export default TextInput
